import React from "react";

const PersonalDetails = ({ customerById }) => {
  const { address, state, pincode, display_name } = customerById;
  return (
    <>
      <div className='pt-3'>
        <div className='settings-form'>
          <h4 className='text-primary'>Personal Details</h4>
          <div className='row'>
            <div className='form-group mb-3 col-md-6'>
              <label className='form-label'>Name</label>
              <input disabled type='text' className='form-control' value={display_name} />
            </div>

            <div className='form-group mb-3 col-md-6'>
              <label className='form-label'>Address</label>
              <input disabled type='text' className='form-control' value={address} />
            </div>
          </div>

          <div className='row'>
            <div className='form-group mb-3 col-md-6'>
              <label className='form-label'>State</label>
              <input disabled type='text' className='form-control' value={state} />
            </div>
            <div className='form-group mb-3 col-md-6'>
              <label className='form-label'>Pin Code</label>
              <input disabled type='text' className='form-control' value={pincode} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalDetails;